import type { Web3DViewer } from '@technology/web3d';
import type { Api } from '@technology/web3d/dist/esnext/Api.js';
import { Web3DPlugin } from '@technology/web3d/dist/esnext/Web3DPlugin.js';
import type { ThreejsModel } from '@technology/web3d-plugin-threejs';
import {
  TextEditingModel,
  type TextEditingModelOptions,
} from './text-editing-model';

export interface CreateTextEditingModelOptions {
  readonly modelId: string;
  readonly viewer: Web3DViewer;
  readonly threejsModel: ThreejsModel;
}

export class TextEditingPlugin extends Web3DPlugin {
  private _api!: Api;

  public get name(): string {
    return 'textEditing';
  }

  public set api(api: Api) {
    this._api = api;
  }

  public createModel(options: CreateTextEditingModelOptions): TextEditingModel {
    const modelOptions: TextEditingModelOptions = {
      modelId: options.modelId,
      viewer: options.viewer,
      threejsModel: options.threejsModel,
      api: this._api,
    };

    const existing = this._api.models?.get(options.modelId);
    if (existing instanceof TextEditingModel) {
      existing.dispose();
    }
    if (existing) {
      void this._api.models.remove(options.modelId);
    }

    const model = new TextEditingModel(modelOptions);
    // Registering makes the Picker call `model.pick()`, which is what lets
    // the standard SelectionTool select text. The model root holds no
    // geometry (meshes live in the threejs model), so keep it out of the scene.
    this._api.models?.add(model, false);
    return model;
  }
}
